import React from "react";

const Heading = () => {
  return (
    <header className="App-header">
      <img
        src="https://pngset.com/images/doubletree-by-hilton-hotel-logo-text-poster-advertisement-alphabet-transparent-png-1087589.png"
        alt="hotel-logo"
        style={{ width: "80px" }}
      />

      <p>CYF Hotel</p>
    </header>
  );
};

export default Heading;
